import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Notfound } from './app/pages/notfound/notfound';
import { authGuard } from './app/core/guards/auth.guard';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            { path: '', component: Dashboard },
            { path: 'products', loadComponent: () => import('./app/pages/products/products').then(m => m.ProductsComponent) },
            { path: 'categories', loadComponent: () => import('./app/pages/categories/categories').then(m => m.CategoriesComponent) },
            { path: 'orders', loadComponent: () => import('./app/pages/orders/orders').then(m => m.OrdersComponent) },
            { path: 'reviews', loadComponent: () => import('./app/pages/reviews/reviews').then(m => m.ReviewsComponent) },
            { path: 'coupons', loadComponent: () => import('./app/pages/coupons/coupons').then(m => m.CouponsComponent) },
            { path: 'users', loadComponent: () => import('./app/pages/users/users').then(m => m.UsersComponent) },
            { path: 'contact', loadComponent: () => import('./app/pages/contact/contact').then(m => m.ContactComponent) },
            { path: 'newsletter', loadComponent: () => import('./app/pages/newsletter/newsletter').then(m => m.NewsletterComponent) },
            { path: 'send-email', loadComponent: () => import('./app/pages/emails/send-email').then(m => m.SendEmailComponent) },
            { path: 'mailbox', loadComponent: () => import('./app/pages/mailbox/mailbox').then(m => m.MailboxComponent) },
            { path: 'settings', loadComponent: () => import('./app/pages/settings/settings').then(m => m.SettingsComponent) },
            { path: 'shipping', loadComponent: () => import('./app/pages/shipping/shipping').then(m => m.ShippingComponent) },
        ]
    },
    { path: 'notfound', component: Notfound },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }
];
